import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js/min';

@Pipe({
  name: 'fullyQualifyPhoneNumber'
})
export class FullyQualifyPhoneNumberPipe implements PipeTransform {

  transform(phoneValue: string, isoCountryCode: string): string {
    phoneValue = phoneValue.trim();
    isoCountryCode = isoCountryCode.trim();
    let transformed: string = phoneValue;
    try
    {
      const phoneNumber = parsePhoneNumber(phoneValue + '', isoCountryCode as CountryCode);
      transformed = phoneNumber.number;
    }
    catch (error) {
      let message: string;
      if (error instanceof Error) message = error.message; else message = String(error);
      console.warn(message);
    }
    return transformed;
  }

}
